export default "__VITE_PUBLIC_ASSET__d3a28d7d__"